import { useEffect } from 'react';

let lockCount = 0;
let originalBodyOverflow = '';
let originalHtmlOverflow = '';
let originalPaddingRight = '';

export const useLockBodyScroll = (locked: boolean) => {
  useEffect(() => {
    if (!locked || typeof document === 'undefined') return;

    const { body, documentElement } = document;
    const scrollbarWidth = window.innerWidth - documentElement.clientWidth;

    if (lockCount === 0) {
      originalBodyOverflow = body.style.overflow;
      originalHtmlOverflow = documentElement.style.overflow;
      originalPaddingRight = body.style.paddingRight;
      
      body.style.overflow = 'hidden';
      documentElement.style.overflow = 'hidden';
      
      if (scrollbarWidth > 0) {
        body.style.paddingRight = `${scrollbarWidth}px`;
      }
    }

    lockCount += 1;

    return () => {
      lockCount = Math.max(0, lockCount - 1);
      if (lockCount === 0) {
        body.style.overflow = originalBodyOverflow;
        documentElement.style.overflow = originalHtmlOverflow;
        body.style.paddingRight = originalPaddingRight;
      }
    };
  }, [locked]);
};
